import type SubjectAddress from '@Domain/Subjects/SubjectAddress';
class FetchDocumentTemplateFile {
	constructor(
		public readonly facilityId: number,
		public readonly subject: SubjectAddress,
		public readonly documentId: number,
		public readonly templateVersionId: number,
	) {
		Object.freeze(this);
	}
}

export default FetchDocumentTemplateFile;
